import React, { useState, useEffect } from "react";
import {  Container, Col, Row, Button, Form} from "react-bootstrap";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.css';
import LoaderBtn from "../components/LoaderBtn";
import useCheckUser from "../custom-hooks/useCheckUser";
import axiosInstance from "../api/axiosInstance";

function Idea() {
  const [category, setCategory] = useState(0);
  const [categoryText, setCategoryText] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [idea, setIdea] = useState("");
  const [description, setDescription] = useState("");
  const [challenge, setChallenge] = useState("");
  const [load, setLoad] =useState(false)
  const UserID = localStorage.getItem("UserId");


  // Example usage of the custom hook
  useCheckUser(UserID); // Replace UserID with the actual user ID value

  useEffect(() => {
      axiosInstance
        .post("GetIdea")
        .then((res) => {
          if (res.data.result === "true") {
            setCategoryList(res.data.data)
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        });
  }, []);


  const handleSubmit = (e) => {
    e.preventDefault();
     if (category === 0 || idea==="" || description === "" || challenge=== "") {
      toast.error("لطفا اطلاعات را تکمیل کنید ", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return;
    }
    setLoad(true)  
    axiosInstance
      .post("InsertIdea", {
        Tittle: idea,
        Text: description,
        Field_Id: category,
        Field: categoryText,
        type: 1 ,
        Chalange: challenge,
      })
      .then((res) => {
        if (res.data.result === "true") { 
          setLoad(false)
          setCategory("")
          setIdea("")
          setDescription("")
          setChallenge("")
          toast.success(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
  };

  const handleChangeCategory = (e) => {
    setCategory(e.target.value);
    setCategoryText(e.target.options[e.target.selectedIndex].text);
  };

  return (
    <div className="rgc-pages">
      <Container>
        <Row className="justify-content-center">
          <Col xs={10} className="rgc-title">
            <h3>ثبت ایده</h3>

            <Form>
              <Row className="justify-content-center">
                <Col md="6" className="mb-3">
                  <Form.Group controlId="formBasicSelect">
                    <Form.Label>دسته:</Form.Label>
                    <Form.Control
                      as="select"
                      browser-default
                      custom-select
                      className="rgc-drop-control"
                      value={category}
                      onChange={(e) => handleChangeCategory(e)}
                    >
                        {" "}
                          <option key={0} value="0">
                            لطفا دسته مورد نظر خود را  انتخاب
                            نمایید
                          </option>
                          {categoryList.map((data, index) => (
                            <option
                              key={index}
                              value={data.id}
                            >
                             {data.Title}
                            </option>
                          ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md="6" className="mb-3">
                  <Form.Group>
                    <Form.Label>عنوان ایده:</Form.Label>
                    <Form.Control
                      className="rgc-font-number"
                      placeholder="عنوان ایده"
                      id="txtname"
                      type="text"
                      value={idea}
                      onChange={(e) => setIdea(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>شرح:</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      className="rgc-font-number"
                      placeholder=" شرح ایده..."
                      type="text"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>ایده شما کدام چالش را برطرف می کند؟</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      className="rgc-font-number"
                      placeholder=""
                      type="text"
                      value={challenge}
                      onChange={(e) => setChallenge(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <br />

                <Col xs="9" md="5"  className="text-center">
                  <Button
                    className="btn-fill rgc-btn"
                    type="submit"
                    variant="primary"
                    onClick={handleSubmit}
                  >
                     <LoaderBtn loads={load} />
                     <span>ثبت</span> 
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
   
    </div>
  );
}

export default Idea;
